// extracted by mini-css-extract-plugin
export var navbarSubLink = "bd_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "bd_y7 d_f0 d_dB";
export var subPageLink = "bd_gf d_gf";
export var burger = "bd_zb";
export var sublinkSize = "bd_zc";
export var linkSize = "bd_zd";
export var Link = "bd_tL y_tL y_sY y_th";